export const createBlacklistObject = (apiObject) => {
  return apiObject.meta.bannedIps.map((bannedIp) => {
    return {
      id: bannedIp.userId,
      ip: bannedIp.ip,
    };
  });
};

export const getBlockedUserRemovedMsg = (ip, locale) => {
  if (locale === 'en') return `User with ${ip} is removed from blacklist.`;

  return `كاربر با آی پی  ${ip} از ليست سياه حذف شد.`;
};
